import {LocalStorageKey} from 'modules/core/models/LocalStorageModel';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import HeaderButton from 'shared/components/layout/HeaderButton';
import useServiceSelected from 'shared/hooks/useServiceSelected';
import {ServiceId} from 'shared/models/RouterParam';
import {AppState} from 'shared/store';
import {getFieldsParametersIndexPath} from '../configs/FieldsRoutePaths';
import FieldIcon from './icons/FieldIcon';

interface MyFieldsHeaderButtonProps {
  alwaysShowTitle?: boolean;
}
const MyFieldsHeaderButton: React.FC<MyFieldsHeaderButtonProps> = (props) => {
  const selected = useServiceSelected(ServiceId.FIELDS);
  const {customer} = useSelector<AppState, AppState['auth']>((state) => state.auth);
  const [path, setPath] = useState<string>('');

  useEffect(() => {
    const lastService: ServiceId | null = localStorage.getItem(LocalStorageKey.LAST_SERVICE_ID) as ServiceId | null;
    //Default view
    let service = ServiceId.IRRIGATION;
    // If no params look for preferences in localstorage
    if (lastService) {
      if (
        lastService !== ServiceId.VISIO_CROP ||
        (lastService === ServiceId.VISIO_CROP && customer && customer.visio_crop_access)
      ) {
        service = lastService;
      }
    }
    const firstPath = getFieldsParametersIndexPath(service);
    setPath(firstPath);
    return () => {};
  });

  return (
    <>
      <HeaderButton
        path={path}
        titleId='fields.headerButton.title'
        icon={<FieldIcon selected />}
        alwaysShowTitle={props.alwaysShowTitle}
        selected={selected}
        //serviceId={ServiceId.FIELDS}
      />
    </>
  );
};

export default MyFieldsHeaderButton;
